
<template>
  <el-dialog
    :title="title"
    :visible.sync="value"
    :before-close="handleCloseDailog"
    width="80%"
    @open="handleOpenDailog"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 类别 -->
        <el-col :span="12">
          <el-form-item
            prop="leibieDictId"
            label="类别"
          >
            <Combox
              v-model="entityData.leibieDictId"
              :disabled="true"
              type-id="D82"
              :option-data="getComboxData('D82')"
              :add-client="false"
            />
          </el-form-item>
        </el-col>

        <!-- 主要用途 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuYaoYongTu"
            label="主要用途"
          >
            <el-input
              v-model="entityData.zhuYaoYongTu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 版本号 -->

        <el-col :span="12">
          <el-form-item
            prop="banBen"
            label="版本号"
          >
            <el-input
              v-model="entityData.banBen"
              disabled
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 更新内容 -->

        <el-col :span="12">
          <el-form-item
            prop="gengXinNeiRong"
            label="更新内容"
          >
            <el-input
              v-model="entityData.gengXinNeiRong"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 已用于 -->
        <el-col :span="12">
          <el-form-item
            prop="usedTo"
            label="已用于"
          >
            <el-input
              v-model="entityData.usedTo"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 使用时间 -->
        <el-col :span="12">
          <el-form-item
            prop="usedDate"
            label="使用时间"
          >
            <el-date-picker
              v-model="entityData.usedDate"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 简介内容 -->
        <el-col :span="24">
          <el-form-item
            prop="jianJieNeiRong"
            label="简介内容"
          >
            <el-input
              v-model="entityData.jianJieNeiRong"
              type="textarea"
              :rows="5"
              clearable
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
      <el-button @click="handleCloseDailog">
        取 消
      </el-button>
    </div>

  </el-dialog>
</template>

<script>

import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
export default {
  components: {
    Combox
  },
  props: {
    value: Boolean,
    typeCode: { type: Number, default: null }, /** 1：创建子版本 2：修改信息 */
    entityId: { type: Number, default: null }
  },
  data() {
    return {
      title: '子版本',
      entityData: {},
      allComboxData: [],
      rules: {
        zhuYaoYongTu: [
          { required: true, message: '请输入主要用途', trigger: 'change,blur' }
        ]
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D82').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {
  },
  activated() {

  },
  methods: {
    /** combox筛选值 */
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /** 关闭窗口 */
    handleCloseDailog() {
      this.$emit('input', false)
    },
    /** 打开窗口 */
    handleOpenDailog() {
      if (this.typeCode === 1) {
        /** 创建子版本 */
        const p = {
          ParentId: this.entityId
        }
        const path = '/api/services/app/GR05/GetCreateChild'
        pathReq.getForm(path, p).then(res => {
          this.entityData = res.data.result.entityData
        })
      } else if (this.typeCode === 2) {
        const p = {
          Id: this.entityId
        }
        const path = '/api/services/app/GR05/GetEditGR05'
        pathReq.getForm(path, p).then(res => {
          this.entityData = res.data.result.entityData
        })
      }
    },
    /** 保存数据 */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/GR05/CreateOrUpdateGR05'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
              that.$emit('input', false)
              this.$emit('save-success')
            })
        }
      })
    }
  }
}
</script>

